import type { CaseItem } from '@/lib/caseTypes';
import { getNodeStyle } from '@/lib/caseMeta';

type Props = {
  timeline: CaseItem['timeline'];
};

const CaseTimeline = ({ timeline }: Props) => (
  <ol className="relative mt-6 border-l border-background-300 pl-6 md:pl-8">
    {timeline.map((node, index) => {
      const style = getNodeStyle(node.type);
      return (
        <li key={`${node.date}-${index}`} className="relative pb-8 last:pb-0">
          <span
            className={`absolute -left-[31px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 md:-left-[39px] ${style.dot}`}
            aria-hidden="true"
          />
          <div className="rounded-lg border border-background-300/70 bg-background-100 p-4 md:p-5">
            <div className="flex flex-wrap items-center gap-2">
              <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${style.chip}`}>
                {node.type}
              </span>
              <time className="text-xs text-foreground-500">{node.date}</time>
            </div>
            <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 md:text-[17px]">{node.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
          </div>
        </li>
      );
    })}
  </ol>
);

export default CaseTimeline;